interface PagerReasonLabels {
  first: string
  previous: string
  next: string
  last: string
  firstPageReason: string
  lastPageReason: string
}

/** Cosmos resolves the boundary from semantics; shared Work pager markup is unchanged. */
export function pagerPassiveReason(element: HTMLElement, labels: PagerReasonLabels): string | undefined {
  if (!element.matches('.fw-list-pager-step')) return undefined
  const label = element.getAttribute('aria-label')
  if (label === labels.first || label === labels.previous) return labels.firstPageReason
  if (label === labels.last || label === labels.next) return labels.lastPageReason
  return undefined
}
